import React from 'react';
import { useTranslation } from 'react-i18next';

interface PrivateEventDetailsProps {
	companyName?: string;
	eventDuration?: string;
	estimatedBudget?: string;
}

export const PrivateEventDetails: React.FC<PrivateEventDetailsProps> = ({ companyName, eventDuration, estimatedBudget }) => {
	if (!companyName && !eventDuration) {
		return null;
	}

	const { t } = useTranslation();

	return (
		<div className="my-6">
			<h4>{t('titles.private_event_details')}</h4>
			{companyName && (
				<div>
					<strong>{t('labels.company_name')}:</strong> {companyName}
				</div>
			)}
			{eventDuration && (
				<div>
					<strong>{t('labels.event_duration')}:</strong> {eventDuration}
				</div>
			)}
			{estimatedBudget && (
				<div>
					<strong>{t('labels.estimated_budget')}:</strong> {estimatedBudget}
				</div>
			)}
		</div>
	);
};
